import type { AuthSession, Clinic } from '@leoclinic/types';
import { MOCK_SESSION as BASE_MOCK_SESSION } from './mock.config';

/** Sessão demo genérica — sem dados de cliente específico */
export function buildMockSession(clinicOverrides: Partial<Clinic> = {}): AuthSession {
  return {
    ...BASE_MOCK_SESSION,
    clinic: BASE_MOCK_SESSION.clinic
      ? { ...BASE_MOCK_SESSION.clinic, ...clinicOverrides }
      : null,
  };
}

export { BASE_MOCK_SESSION as MOCK_SESSION_BASE };
